import React, { Component } from 'react';
import radium, { Style } from 'radium';
import Slider from 'antd/lib/slider';

class SliderReviewCard extends Component {
  static styles = {};

  constructor(props) {
    super(props);
    this.state = {
      sliderCurrentValue: 0
    };
  }

  componentDidMount() {
    this.refs.sliderCurrentValue.innerHTML = 0;
  }

  handleSecondSlider = (value) => {
    this.setState({ sliderCurrentValue: value });
    this.refs.sliderCurrentValue.innerHTML = value;
  };

  sliderValueChanged = () => {
    this.props.getAllPeerQResponse(this.props.index, this.state.sliderCurrentValue, 'slider');
  };

  render() {
    const styles = SliderReviewCard.styles;
    const maxScore = this.props.maxScore || 10;
    return (
      <div className="sliderReviewCard">
        <div className="sliderContainer">
          <Slider
            min={0}
            max={maxScore}
            step={1}
            defaultValue={0}
            value={this.state.sliderCurrentValue}
            onChange={this.handleSecondSlider}
            onAfterChange={this.sliderValueChanged}
            style={styles.inline.sliderRoot}
            sliderStyle={styles.sliderStyle}
          />
          <div
            style={[styles.sliderValueContainer, styles.displayFlexRow, styles.alignItemsCenter]}
          >
            <span className="sliderValue" ref="sliderCurrentValue" />
            <span className="sliderMaxValue">
/
              {maxScore}
            </span>
          </div>
        </div>
        <Style rules={styles.classBased} scopeSelector=".sliderReviewCard" />
      </div>
    );
  }
}

SliderReviewCard.styles = {
  inline: {
    sliderRoot: {
      width: '210px'
    }
  },
  classBased: {
    '': {},
    '.sliderContainer': {
      maxWidth: '70%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    '.sliderValue': {
      fontSize: '16px',
      lineHeight: '22px',
      fontWeight: '500',
      color: '#00b6e8'
    },
    '.sliderMaxValue': {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: '500',
      color: '#b5bcc4'
    }
  },
  sliderStyle: {
    margin: '0px'
  },
  sliderValueContainer: {
    marginLeft: '10px'
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  alignItemsCenter: {
    alignItems: 'center'
  }
};

export default radium(SliderReviewCard);
